import { BeneficiariesState } from './types';

const defaultBeneficiariesState: BeneficiariesState = {
  beneficiaries: null,
  totalBeneficiaries: 0,
  selectedBeneficiary: null,
  action: null,
  onBeneficiaryAction: () => {},
  onDeleteBeneficiary: () => {},
  onResetSelectedBeneficiary: () => {},
  onBeneficiariesListFiltersChange: () => {},
  beneficiaryToDelete: null,
  filters: {
    perPage: 10,
    page: 0,
  },
  loadingState: {
    isLoadingBeneficiaries: false,
    isLoadingDeleteBeneficiary: false,
  },
  errorState: {
    beneficiariesDataError: undefined,
    deleteBeneficiaryError: undefined,
  },
  deleteBeneficiaryData: null,
  beneficiariesRefetch: undefined,
};

export { defaultBeneficiariesState };
